/*
 * @Author: your name
 * @Date: 2022-03-09 14:16:09
 * @LastEditTime: 2022-03-28 11:30:33
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\language\yh_en.js
 */
export default {
  basics: {
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    en: 'EN',
    zh: 'ZH',
    PleaseSelect: 'Please select',
    PleaseInput: 'Please input',
  },
  schedule: {
    //节目编辑
    Screenshot: 'Screenshot',
    ProgramName: 'Program name',
    Structure: 'Structure',
    Resolution: 'Resolution',
    CreationTime: 'CreationTime',
    operate: 'Operate',
    AllLoaded: 'All loaded',
    materialsLoaded: 'Click to load material',
    NewProgram: 'New program',
    DelProgram: 'Do you want to permanently delete the currently selected program?',
    DeleteMedia: 'Delete media',
    DeleteProgram: 'Del program',
    //高级发布
  },
  review: {
    Screenshot: 'Screenshot',
    ProgramName: 'Program name',
    Structure: 'Structure',
    Resolution: 'Resolution',
    CreationTime: 'CreationTime',
    operate: 'Operate',
    Review: 'Review',
    Check: 'Check',
    ProgramMaterial: 'Program material',
    ProgramPreview: 'Program preview',
    ReviewContent: 'Please enter review content',
    Approved: 'Approved',
    RejectReview: 'Reject review',
    DeleteAll: 'Confirm delete all?',
    Name: 'Name',
    Size: 'Size',
    Preview: 'Preview',
    ProgramReview: 'Program review',
    ReasonRefusal: 'Please fill in the reason for refusal!',
    number: 'No release ticket number is selected',
  },
  system: {
    // 组织结构
    StructureName: 'StructureName',
    Operate: 'Operate',
    NewStructure: 'New structure',
    DeleteStructure: 'Delete structure',
    Structure: 'Structure',
    MsgDeleteStructure: 'Permanently delete the current',
    OnDevice: 'Turn on device',
    OffDevice: 'Turn off device',
    inquiry: 'IF',
    on: 'on',
    off: 'off',
    slaveDevice: 'the current or slave device',
    CloseCurrent: 'Close current',
    CloseSlave: 'Close slave',
    OpenCurrent: 'Open current',
    OpenSlave: 'Open slave',
    // 用户管理
    Account: 'Please enter your account',
    Name: 'Name',
    Role: 'Role',
    Grade: 'Grade',
    Remark: 'Remark',
    RoleName: 'Role name',
    Password: 'Please enter password',
    ConfirmPass: 'Confirm Pass',
    Mail: 'Mail',
    DeleteUser: 'Delete user',
    DeleteRole: 'Permanently delete current role',
    UnblockDevice: 'Unblock device',
    banDevice: 'Ban device',
    Unblock: 'Unblock',
    ban: 'Forbidden',
    BanTheCurrent: 'Ban the current',
    BannedAffiliate: 'Banned affiliate',
    ReleaseTheCurrent: 'Release the current',
    ReleaseTheSubordinate: 'Release the subordinate',
    AddUser: 'Add user',
    ModifyUser: 'Modify user',
    inputPassword: 'Please enter confirm password',
    noPassword: 'Passwords entered twice do not match!',
    inputName: 'Please enter name',
    RoleEmpty: 'Role name cannot empty',
    StructureEmpty: 'Structure name cannot empty',
    AccountEmpty: 'Account not allowed empty',
    AccountAstrict: 'Account only contain numbers, letters, and underscores!',
    AccountLength: 'Please set account length 3~20 characters!!',
    AccountRegistered: 'Current account has been registered, please re-enter!',
    // 角色管理
    AddRole: 'Add role',
    RoleRemark: 'Role remark',
    RightConfig: 'Right config',
    DelRole: 'Delete role',
    // 系统设置
    imageSize1: 'Suggest 920x940 pixels PNG format',
    ReplacePicture: 'Replace picture',
    LoginLogo: 'Login page LOGO',
    imageSize2: 'Suggest 360x80 pixels PNG format',
    SystemLogo: 'System page LOGO',
    systemSettings: 'Other system settings',
    configInformation: 'Other config information',
    DailyLimit: 'Daily application limit',
    UploadedType: 'Uploaded avatar image can only PNG format!',
    UploadedSize: 'Size of the uploaded avatar image cannot exceed 2MB!',
    // 节点管理
    addNode: 'Add node',
    EnglishName: 'EnglishName',
    ChineseName: 'ChineseName',
    delNode: 'Permanently delete current role ?',
    // 软件授权
    AuthorizationType: 'Code type',
    Model: 'Model',
    Date: 'Date',
    AuthorizationCode: 'Authorization Code',
    NewAccounts: 'New accounts' // New accounts
  },
  // 节目编辑
  programEditing: {
    Setting: 'Setting',
    Save: 'Save',
    Release: 'Release',
    Quit: 'Quit',
    ExitEditProgram: 'Exit will discard  currently edited program',
    DragMaterial: 'Drag the material file here',
    SaveWait: 'Screenshots and saving, please wait ...',
    ProgramList: 'Window List',
    multimedia: 'Multimedia',
    AddMultimedia: 'Add multimedia',
    Insert: 'Insert at current position',
    properties: 'Properties',
    materialNull: '',
    Uploaded: 'Uploaded',
    AllLoaded: 'All loaded',
    materialsLoaded: 'Click to load material',
    Text: 'Text',
    Digital: 'Digital clock',
    Analog: 'Analog clock',
    Weather: 'Weather',
    Timing: 'Timing',
    Countdown: 'Countdown',
    StreamMedia: 'Stream media',
    RSS: 'RSS',
    Window: 'Window',
    Picture: 'Picture',
    Video: 'Video',
    Delete: 'Delete',
    Webpage: 'Webpage',
    OneLayerUp: 'One layer up',
    OneLayerDown: 'One layer down',
    Top: 'Top',
    Bottom: 'Bottom',
    Full: 'Full',
    HorizontalFull: 'Horizontal full',
    VerticalFull: 'Vertical full',
    VerticalDown: 'Vertical down',
    VerticalMiddle: 'Vertical middle',
    VerticalTop: 'Vertical top',
    HorizontalLeft: 'Horizontal left',
    HorizontalCenter: 'Horizontal center',
    HorizontalRight: 'Horizontal right',

    ProgramName: 'Program name',
    Structure: 'Structure',
    DeviceType: 'Dvice type',
    Resolution: 'Resolution',
    CustomResolution: 'Custom resolution',
    Device: 'Device',
    SelectDevice: 'Select device',
    SelectTerminal: 'Select publishing Terminal',
    TerminalName: 'Terminal Name',
    DeviceStatus: 'Status',
    Offline: 'Offline',
    AdaptiveScreen: 'Adaptive screen size playback',
    Tip: 'Tip',
    Thumbnail: 'Thumbnail',
    Name: 'Name',
    version: 'Version number',

    Title: 'Title',
    TimerMode: 'Timer Mode',
    RelativeTime: 'Relative Time',
    AbsoluteTime: 'Absolute Time',
    DisplayMode: 'Display Mode',
    Day: 'Day',
    Hour: 'Hour',
    Minutes: 'Minutes',
    Second: 'Second',
    EditStyle: 'Edit Style',
    DisplayUsage: 'Edit Style',
    ARow: 'DT',
    MultiRow: 'MT',
    FontFamily: 'Font Family',
    BackgroundColor: 'Back Ground Color',
    FontColor: 'Font Color',
    PlayTime: 'Program Duration',
    Describe: 'Describe',
    HourMark: 'Hour Mark',
    HourHand: 'Hour Hand',
    MinutesMark: 'Minutes Mark',
    MinutesHand: 'Minutes Hand',
    background: 'background',
    secondHand: 'Second Hand',
    DateAndDay: 'Date And Day',
    Display: 'Display',
    SelectTimeZone: 'Select Time Zone',
    Scale: 'Scale',
    ConstrainProportions: 'Constrain Pro-Portions',
    EnterTheAnimation: 'Enter The Animation',
    TheEntryTime: 'The Entry Time',
    Data: 'Data',
    Time: 'Time',
    ChineseCalendar: 'Calendar',
    Week: 'Week',
    DateFormat: 'DateFormat',
    Font: 'Font',
    Roll: 'Roll',
    FlipOver: 'FlipOver',
    Motionless: 'Motionless',
    RollingDirection: 'Rolling Direction',
    RollingVelocity: 'Rolling Velocity',
    FromLeftToRight: 'From Left To Right',
    FromRightToLeft: 'From Right To Left',
    FromTopToBottom: 'From Top To Bottom',
    FromTheBottomUp: 'From the Bottom Up',
    Attribute: 'Attribute',
    AttendedMode: 'Attended Mode',
    EndToEnd: 'End To End',
    VolumeAdjust: 'Volume Adjust',
    Duration: 'Duration',
    Address: 'Address',
    City: 'City',
    Temp: 'Temp',
    WindPower: 'Wind Power',
    Humidity: 'Humidity',
    DressingIndex: 'Dressing Index',
    PlayTheWay: 'Play The Way',
    TimeFormat1: '00:00:00:00',
    TimeFormat2: '00D 00H 00M 00S',
  }
}